import _ from 'underscore';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';
import {
  IActivity, IActivityFactory, IActivitySchema, ILoggers, IScenario,
} from './types';

// Activity class to create an instance of an Activity
// @ts-ignore : The logging methods are dynamically added.
class Activity implements IActivity {
  id: string;

  name: string;

  setting: any;

  value: any;

  // Allow for dynamically added log methods
  [key: string]: any;

  constructor(
    scenario: IScenario,
    activitySchema: IActivitySchema,
    loggers: ILoggers,
    parentScenario: IScenario,
  ) {
    const simpleActivity = (typeof activitySchema === 'string');
    this.name = simpleActivity ? activitySchema : activitySchema.name;
    this.value = simpleActivity ? activitySchema : activitySchema.value;
    this.setting = simpleActivity ? undefined : activitySchema.setting;
    this.id = generateGuid();

    // Add logger methods on the activity
    _.each(loggers, (logger: any) => {
      const logMethods = logger.getLogMethods();
      _.each(logMethods, (logMethod) => {
        this[logMethod] = (...args: any[]) => logger[logMethod](scenario, this, parentScenario, args);
      });
    });
  }
}

/**
 * ActivityFactory class responsible for creating Activity
 */
export class ActivityFactory implements IActivityFactory {
  activitySchema: IActivitySchema;

  loggers: ILoggers;

  parentScenario: IScenario;

  scenario: IScenario;

  /**
   * @param {object} scenario - scenario the activity belongs to
   * @param {object} activitySchema - schema of scenario to be created
   * @param {object} loggers - available loggers
   * @param {object} parentScenario - parentScenario of the scenario
   */
  constructor(
    scenario: IScenario,
    activitySchema: IActivitySchema,
    loggers: ILoggers,
    parentScenario: IScenario,
  ) {
    this.scenario = scenario;
    this.activitySchema = activitySchema;
    this.parentScenario = parentScenario;
    this.loggers = loggers;
  }

  create(): IActivity {
    // @ts-ignore : The logging methods are dynamically added.
    return new Activity(this.scenario, this.activitySchema, this.loggers, this.parentScenario);
  }
}
